import { render, staticRenderFns } from "./CustomerActivityLog.vue?vue&type=template&id=6c3dd04c"
import script from "./CustomerActivityLog.vue?vue&type=script&lang=js"
export * from "./CustomerActivityLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports